<template>
  <div class="mobile-menu px-6 py-8">
    <nav v-if="show && items.length" class="mb-8">
      <a
        v-for="item in items"
        :key="item.anchor"
        :href="item.href"
        class="block py-4 border-b border-gray-5"
        @click="$emit('navigate')"
      >
        <TypeBody
          variant="large"
          weight="strong"
          :class="color === 'white' ? 'text-white' : 'text-primary'"
        >
          {{ item.desktop }}
        </TypeBody>
        <div
          class="text-14"
          :class="color === 'white' ? 'text-white' : 'text-gray-3'"
        >
          {{ item.subtitle }}
        </div>
      </a>
    </nav>
    <div class="login-buttons mb-8">
      <BaseButton
        variant="secondary"
        size="large"
        class="block w-full mb-4"
        @click="$router.push('/registration/company-size')"
        >{{ text }}</BaseButton
      >
      <BaseButton
        variant="inverted"
        size="large"
        class="block w-full"
        @click="sendTo"
        >{{ mobileMenuButtonText }}</BaseButton
      >
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { BaseButton, TypeBody } from '@bambeehr/pollen';

export default defineComponent({
  name: 'MobileMenu',
  components: {
    BaseButton,
    TypeBody,
  },
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    // Resolved nav links ({ desktop, subtitle, anchor, href }); HomeNav owns the list.
    items: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: 'Try Bambee Now',
    },
    mobileMenuButtonText: {
      type: String,
      default: 'Log In',
    },
  },
  setup() {
    const sendTo = () => {
      window.location.href = `https://${process.env.APP}`;
    };

    return { sendTo };
  },
});
</script>

<style scoped>
.mobile-menu {
  height: calc(100vh - 72px);
  overflow-y: auto;
}
</style>
